var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadBigArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-big-arrow",
    transform: "translate(6.986 -0.154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30580",
    "data-name": "Rectangle 30580",
    width: 60,
    height: 60,
    transform: "translate(-6.986 0.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_138594",
    "data-name": "Group 138594",
    transform: "translate(12.977 12.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296502",
    "data-name": "Path 296502",
    d: "M105.953,35.273h3.722l-.106,14.733a2.027,2.027,0,0,0,2.027,2.027h5.533a2.027,2.027,0,0,0,2.027-2.027l.106-14.733h3.72a1.522,1.522,0,0,0,1.076-2.6l-8.514-8.515a1.525,1.525,0,0,0-2.154,0l-8.513,8.515a1.523,1.523,0,0,0,1.076,2.6Z",
    transform: "translate(-104.431 -23.714)",
    fill: "#3d6afd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_138595",
    "data-name": "Group 138595",
    transform: "translate(-0.007 28.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296503",
    "data-name": "Path 296503",
    d: "M43.751,220.029a2.394,2.394,0,0,0-2.288,2.488v10.4a5.447,5.447,0,0,1-5.2,5.652H9.779a5.446,5.446,0,0,1-5.2-5.652v-10.4a2.4,2.4,0,0,0-2.289-2.488A2.4,2.4,0,0,0,0,222.517v10.4c0,5.86,4.387,10.628,9.779,10.628H36.262c5.392,0,9.779-4.768,9.779-10.628v-10.4A2.4,2.4,0,0,0,43.751,220.029Z",
    transform: "translate(0 -220.029)",
    fill: "#3d6afd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBigArrow);
export default __webpack_public_path__ + "static/media/upload-big-arrow.542c20ef3bfab8d36ac65d9baa2c06d7.svg";
export { ForwardRef as ReactComponent };